import React from 'react';
import { Alert as ChakraAlert, AlertIcon, AlertProps } from '@chakra-ui/react';

interface Props extends AlertProps {
  errorText: string;
}

export const Alert = ({ errorText, ...props }: Props): JSX.Element => {
  const { status = 'success', variant = 'left-accent' } = props;

  return (
    <ChakraAlert status={status} variant={variant}>
      <AlertIcon />
      {errorText}
    </ChakraAlert>
  );
};
